import React, { useState, useEffect } from "react";

import Head from "next/head";

import FooterNavComponent from "../../components/FooterComponent/FooterNavComponent/FooterNavComponent";
import GetInTouchComponent from "../../components/FooterComponent/GetInTouchComponent/GetInTouchComponent";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import TrustedByComponent from "../../components/HomeComponent/TrustedByComponent/TrustedByComponent";
import MeetTheTeamComponent from "../../components/MeetTheTeamComponent/MeetTheTeamComponent";
import { NextHead } from "../../components/NextHead/NextHead";
import { _fetchCmsPageData, _fetchFooterCmsData } from "../../helper/service";
import { AxiosInstance } from "../../utilities";

const initialCMSData = () => {
  return {
    team_members: null,
    main_section: null,
    heading: null,
    sub_heading: null,
  };
};

export default function MeetTheTeamPage(props) {

  let trustedByData = null;
  if(Array.isArray(props.homeCmsData) ){
    let val = props.homeCmsData.find(item => item.key === "trustedBy");
    if(val){
      trustedByData = val;
    }
  }
  const [teamCmsData, setTeamCmsData] = useState(
    props.cmsData || {
      team_members: null,
      main_section: null,
      heading: null,
      sub_heading: null,
    }
  );

  useEffect(() => {
    if (!props.cmsData) {
      fetchCmsData();
    }
  }, []);

  const fetchCmsData = () => {
    let params = { slug: "meet-the-team" };
    if (props.previewKey) {
      params.previewKey = props.previewKey;
    }
    AxiosInstance(4008, "application/json")
      .post("/pages", params)
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          const responseData = response.data;
          const teamCmsDataClone = { ...teamCmsData };

          responseData &&
            responseData.data.forEach((item) => {
              if (item.key === "team_members") {
                teamCmsDataClone.team_members = item;
              }
              if (item.key === "main_section") {
                teamCmsDataClone.main_section = item;
              }
              if (item.key === "heading") {
                teamCmsDataClone.heading = item;
              }
              if (item.key === "sub_heading") {
                teamCmsDataClone.sub_heading = item;
              }
            });
          setTeamCmsData(teamCmsDataClone);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <React.Fragment>
      <NextHead {...props.seo} />
      <Head>
        <link rel="canonical" href={`${process.env.BASE_URL}/meet-the-team`} />
      </Head>
      <HeaderComponent />
      <MeetTheTeamComponent data={teamCmsData} />
      <div className="about_us_trutedby_container">
        <TrustedByComponent trustedByData={trustedByData} />
      </div>
      <GetInTouchComponent />
      <FooterNavComponent footerData={props.footerData} />
    </React.Fragment>
  );
}

export async function getServerSideProps(context) {
  let cmsData = initialCMSData();
  let seo = {};
  let footerData = null;
  let homeCmsData = {};

  // fetching cms data
  const cmsResponse = await _fetchCmsPageData({ slug: "meet-the-team" });
  seo = cmsResponse?.seo || {};
  if (Array.isArray(cmsResponse?.data)) {
    cmsResponse.data.forEach((item) => {
      if (
        ["team_members", "main_section", "heading", "sub_heading"].includes(
          item.key
        )
      ) {
        cmsData[item.key] = item;
      }
    });
  }
  // fetching cms data ends

  //fetching home cms data for trusted by components
  const homeCmsResponse = await _fetchCmsPageData({ slug: "home" });
  if (homeCmsResponse) {
    homeCmsData = cmsResponse.data;
  }
  //fetching home cms data for trusted by components ends

  //Fetching footerData
  footerData = await _fetchFooterCmsData();
  //Fetching footerData ends

  return { props: { cmsData, seo, footerData, homeCmsData } };
}
